import script from "./ProductItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductItem.vue?vue&type=script&setup=true&lang=ts"

import "./ProductItem.vue?vue&type=style&index=0&id=482d2fcc&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-482d2fcc"]])

export default __exports__